module.exports = __webpack_public_path__ + "img/portrait-046.6421ba84.jpg";